import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ForecastVersionResponse } from '@api-response-types/forecast-version.response';

import { ReportingResultSetStatus } from '@api-types/enums/reporting-result-set-status.enum';
import {
  FormFieldComponent,
  FormInputSelectComponent,
  PmDialogComponent,
} from '@libs/ui';
import { TranslateModule } from '@ngx-translate/core';
import { formatValueAsDate } from '@core/utils/formatter-utility';

export interface ReportingImportDialogData {
  importableVersions: ForecastVersionResponse[];
}

@Component({
  selector: 'pm-reporting-import-dialog',
  templateUrl: './reporting-import-dialog.component.html',
  imports: [
    FormsModule,
    TranslateModule,
    PmDialogComponent,
    FormFieldComponent,
    FormInputSelectComponent,
  ],
})
export class ReportingImportDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<ReportingImportDialogComponent>,
  );

  public importableVersions = signal<ForecastVersionResponse[]>([]);

  protected readonly selectedVersionId = signal<string | null>(null);

  protected readonly versionOptions = computed(() =>
    this.importableVersions().map((v) => {
      let label = `FC ${formatValueAsDate(v.createdAt)}`;
      if (v.reportingStatus === ReportingResultSetStatus.IMPORTING)
        label += ' (importing...)';
      if (v.reportingStatus === ReportingResultSetStatus.FAILED)
        label += ' (failed)';
      return { value: v.id, label, createdAt: v.createdAt };
    }),
  );

  protected readonly buttonConfigs = computed(() => ({
    cancelConfig: { handleClick: () => this.onCancel() },
    submitConfig: {
      text: 'REPORTING.IMPORT_DIALOG.START_IMPORT',
      disabled: !this.selectedVersionId(),
      handleClick: () => this.onImport(),
    },
  }));

  protected onCancel(): void {
    this.dialogRef.close(null);
  }

  protected onImport(): void {
    this.dialogRef.close(this.selectedVersionId());
  }
}
